<template>
  <v-form v-model="isFormValid">
    <v-row>
      <v-spacer />
      <v-col cols="8" sm="6" md="4" class="text-center">
        <v-text-field v-model="oldPassword" :label="$t('change_pwd_old_password_field')" :rules="[
          inputRules.required,
          inputRules.passwordLength,
          inputRules.password
        ]" outlined color="primary-1" autofocus :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showOldPassword = !showOldPassword" :type="showOldPassword ? 'text' : 'password'"
          :error-messages="wrongPassword ? $t('change_pwd_old_password_error') : ''" @input="inputField">
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-text-field>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-spacer />
      <v-col cols="11" sm="8" class="text-center mb-5" v-html="$t('change_pwd_notification')">
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <v-spacer />
      <v-col cols="8" sm="6" md="4" class="text-center">
        <v-text-field v-model="newPassword" :label="$t('change_pwd_new_password_field')" :rules="[
          inputRules.required,
          inputRules.passwordLength,
          inputRules.password
        ]" outlined color="primary-1" :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showNewPassword = !showNewPassword" :type="showNewPassword ? 'text' : 'password'">
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-text-field>
        <v-text-field v-model="confirmPassword" :label="$t('change_pwd_new_password_again')"
          :rules="[inputRules.required, inputRules.matchPassword]" outlined color="primary-1"
          :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showConfirmPassword = !showConfirmPassword" :type="showConfirmPassword ? 'text' : 'password'"
          @input="inputFieldConfirm" :error-messages="passwordNotMatch ? $t('change_pwd_new_password_error') : ''
            ">
          <template #message="{ message }">
            {{ $t(message) }}
          </template>
        </v-text-field>
        <v-btn depressed block x-large class="mt-10 font-weight-bold nextBtn"
          :class="{ disabledBtn: !isFormValid || !loadingFinished }" :disabled="!isFormValid || !loadingFinished"
          @click="changePassword">
          <template v-if="!loadingFinished">
            <v-progress-circular indeterminate color="white" size="25" width="2"></v-progress-circular>
          </template>
          <template v-else>
            {{ $t('change_pwd_cta') }}
          </template>
        </v-btn>
      </v-col>
      <v-spacer />
    </v-row>
  </v-form>
</template>

<script>
import inputRulesJS from "@/shared/inputRules.js";
import UM from "@/api/user-management";
import { mapActions } from "vuex";
import md5 from "js-md5";

export default {
  data() {
    return {
      isFormValid: false,
      oldPassword: "",
      wrongPassword: false,
      newPassword: "",
      confirmPassword: "",
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      inputRules: {
        required: inputRulesJS.required,
        passwordLength: inputRulesJS.passwordLength,
        password: inputRulesJS.password,
        matchPassword: () => {
          return (
            this.confirmPassword === this.newPassword ||
            this.$t('change_pwd_not_match')
          );
        }
      },
      loadingFinished: true,
      passwordNotMatch: false
    };
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      showLogIn: "login/show",
      logout: "user/logout"
    }),

    async changePassword() {
      if (this.confirmPassword !== this.newPassword)
        return (this.passwordNotMatch = true);

      this.loadingFinished = false;
      const { data: updateUserInfoRes } = await UM.updateUserInfo({
        password: md5(this.oldPassword),
        newPassword: md5(this.newPassword)
      });
      // console.log(
      //   `${String.fromCodePoint(128049)} [UM] updateUserInfo`,
      //   updateUserInfoRes
      // );
      if (updateUserInfoRes.errCode === "00") {
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-success@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('change_pwd_submit_success')}</div>
          </div>`
        });
        setTimeout(() => {
          this.logout();
          this.showLogIn();
        }, 2000);
      } else {
        // todo handle error of wrong orgin password
        if (updateUserInfoRes.errCode == "108") this.wrongPassword = true;
        this.showDialog({
          alert: true,
          content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('change_pwd_submit_fail')}<br>${updateUserInfoRes.errDetail
            }</div>
          </div>`
        });
        console.log(
          `密碼修改失敗\nerrCode: ${updateUserInfoRes.errCode}\nerrMsg: ${updateUserInfoRes.errMsg
          }\nerrDetail: ${updateUserInfoRes.errDetail}`
        );
      }
      this.loadingFinished = true;
    },
    inputField() {
      this.wrongPassword = false;
    },
    inputFieldConfirm() {
      this.passwordNotMatch = false;
    }
  },
  mounted() {
    this.$store.dispatch("setOverlayLoading", false);
  }
};
</script>

<style lang="scss" scoped></style>
